/**
 * Push the live recording state to the desktop menu bar (tray) icon.
 *
 * No-op off the desktop shell (web / PWA). Mirrors the `tauriInvoke` pattern in
 * lib/system-audio.ts: guarded by {@link IS_TAURI} + a dynamic import so the
 * `@tauri-apps/api` dependency never loads in the browser bundle path.
 */
import type { TProduct } from "@lexicanon/shared"
import { IS_TAURI } from "./runtime-origin"
import type { TTrayStatus } from "./tray-status"

/** Theme the tray glyph (`product`) and select its look (`status`). No-op off-desktop. */
export async function setTrayStatus(product: TProduct, status: TTrayStatus): Promise<void> {
  if (!IS_TAURI) return
  try {
    const { invoke } = await import("@tauri-apps/api/core")
    await invoke("set_tray_state", { product, status })
  } catch (err) {
    console.info("[desktop-tray] set_tray_state failed (older shell or off-desktop?)", err)
  }
}
